<template>
  <div class="channel-access-backdrop" @click.stop @keydown.stop="onKeydown">
    <section class="channel-access-dialog" role="dialog" aria-modal="true" :aria-labelledby="messageId" tabindex="-1">
      <div class="channel-access-icon" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="5" y="10" width="14" height="11" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </div>
      <p :id="messageId" class="channel-access-message">{{ message }}</p>
      <button ref="confirm" class="button-primary channel-access-confirm" type="button" @click.stop="$emit('close')">{{ $t('OK') }}</button>
    </section>
  </div>
</template>
<script>
let openDialogs = 0;
let previousOverflow = '';
export default {
  name: 'ChannelAccessDialog',
  props: { message: { type: String, required: true } },
  computed: { messageId() { return `channel-access-message-${this._uid}`; } },
  mounted() {
    this.previousFocus = document.activeElement;
    // Cards may create transformed stacking contexts. Mount above them and the player.
    const host = document.fullscreenElement || document.webkitFullscreenElement || document.body;
    host.appendChild(this.$el);
    if (openDialogs++ === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    this.$nextTick(() => this.$refs.confirm && this.$refs.confirm.focus());
  },
  beforeDestroy() {
    if (--openDialogs === 0) document.body.style.overflow = previousOverflow;
    if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
    if (this.previousFocus && this.previousFocus.isConnected) this.previousFocus.focus();
  },
  methods: {
    onKeydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); this.$emit('close'); }
      if (event.key === 'Tab') { event.preventDefault(); this.$refs.confirm.focus(); }
    }
  }
};
</script>
<style scoped>
.channel-access-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000000000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, .76);
  cursor: default;
}
.channel-access-dialog {
  box-sizing: border-box;
  width: 100%;
  max-width: 460px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  padding: 32px;
  border: 1px solid #393939;
  border-radius: 12px;
  background: #181818;
  box-shadow: 0 24px 80px rgba(0, 0, 0, .5);
  color: #fff;
  text-align: center;
  font-family: inherit;
}
.channel-access-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin: 0 auto 20px;
  border: 1px solid #444;
  border-radius: 50%;
  color: #f4f4f4;
  background: #252525;
}
.channel-access-message {
  margin: 0 0 28px;
  color: #f5f5f5;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.6;
  white-space: normal;
  overflow-wrap: anywhere;
}
.channel-access-confirm {
  display: block;
  width: 100%;
  min-height: 46px;
  padding: 12px 24px;
  border: 0;
  border-radius: 6px;
  background: var(--primary-btn-color, #f6921e);
  color: var(--clr-button-primary-colors, #111);
  font: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
.channel-access-confirm:hover { filter: brightness(1.1); }
.channel-access-confirm:focus-visible { outline: 2px solid #fff; outline-offset: 4px; }
.channel-access-confirm:active { filter: brightness(.9); }
@media (max-width: 480px) {
  .channel-access-backdrop { padding: 16px; }
  .channel-access-dialog { padding: 28px 24px; max-height: calc(100vh - 32px); }
  .channel-access-message { font-size: 16px; }
}
</style>
